if (!customElements.get('order-bump')) {
  customElements.define(
    'order-bump',
    class OrderBump extends HTMLElement {
      constructor() {
        super();
        this.onCartChange = this.onCartChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
      }

      connectedCallback() {
        this.productId = parseInt(this.dataset.productId, 10);
        this.variantIds = (this.dataset.variantIds || '')
          .split(',')
          .map((id) => parseInt(id, 10))
          .filter(Boolean);

        this.form = this.querySelector('[data-order-bump-form]');
        this.select = this.querySelector('[data-order-bump-select]');
        this.idInput = this.querySelector('[data-order-bump-id]');
        this.button = this.querySelector('[data-order-bump-btn]');
        this.priceEl = this.querySelector('[data-order-bump-title-price]');
        this.compareEl = this.querySelector('[data-order-bump-title-compare]');

        if (this.select) {
          this.select.addEventListener('change', this.onSelectChange);
        }

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit);
        }

        document.addEventListener('theme:cart:change', this.onCartChange);

        // Re-check visibility in case cart already contains this product
        // (server already handled initial state, but this guards against stale renders)
        this.refreshVisibility();
      }

      disconnectedCallback() {
        document.removeEventListener('theme:cart:change', this.onCartChange);
      }

      onSelectChange() {
        const option = this.select.options[this.select.selectedIndex];
        if (!option) return;

        this.idInput.value = option.value;

        const price = parseInt(option.dataset.price, 10);
        const compare = parseInt(option.dataset.compareAtPrice, 10);
        const available = option.dataset.available === 'true';

        if (this.priceEl && !isNaN(price)) {
          this.priceEl.textContent = this.formatMoney(price);
        }
        if (this.compareEl) {
          if (compare && compare > price) {
            this.compareEl.textContent = this.formatMoney(compare);
            this.compareEl.hidden = false;
            this.querySelector('[data-order-bump-price-wrap]')?.classList.add('order-bump__price--sale');
          } else {
            this.compareEl.hidden = true;
            this.querySelector('[data-order-bump-price-wrap]')?.classList.remove('order-bump__price--sale');
          }
        }
        if (this.button) {
          this.button.disabled = !available;
        }
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.button.disabled) return;

        // Hand off to the theme's existing cart-add handler, which reads the
        // form via button.closest('form'), shows loading state, refreshes the
        // cart drawer, and fires theme:cart:change when done.
        document.dispatchEvent(
          new CustomEvent('theme:cart:add', {
            detail: { button: this.button },
            bubbles: false,
          })
        );
      }

      onCartChange() {
        this.refreshVisibility();
      }

      refreshVisibility() {
        fetch(`${window.theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            const inCart = (cart.items || []).some(
              (item) => item.product_id === this.productId
            );
            this.classList.toggle('order-bump--hidden', inCart);
          })
          .catch(() => {});
      }

      formatMoney(cents) {
        if (window.theme && typeof window.theme.formatMoney === 'function') {
          return window.theme.formatMoney(cents, window.theme.moneyFormat);
        }
        return `$${(cents / 100).toFixed(2)}`;
      }
    }
  );
}
